import React from "react";
import { Card } from "@aws-amplify/ui-react";
import './MiniStatics.css';
interface MiniStatisticProps {
  title: string;
  amount: string;
  percentage?: string;
  progress?: string;
  bgcolor?: string;
  textcolor?: string;
}

const MiniStatistics = (props: MiniStatisticProps) => {
  return (
    <Card height="100%" borderRadius="15px" className="bg-gradient-red" style={{background:props.bgcolor}}>
      <div className="card-content">
        <div className="card-title"> {props.title} </div>
        <div className="card-statistics-amount"  style={{color:props.textcolor}}>{props.amount}</div>
        <div className="progress">
          {props.percentage?<span>{props.percentage}</span>:null}
          <span>{props.progress}</span>
        </div>
      </div>
    </Card>
  );
};

export default MiniStatistics;
